import { PageHead } from '../../components/ui/PageHead';
import { TableOfContents } from '../../components/navigation/TableOfContents';
import { ArticleBody } from '../../components/content/ArticleBody';
import styles from './TermsPage.module.css';

const tocItems = [
  { id: 'acceptance', label: 'Acceptance of Terms' },
  { id: 'services', label: 'Use of Services' },
  { id: 'intellectual-property', label: 'Intellectual Property' },
  { id: 'confidentiality', label: 'Confidentiality' },
  { id: 'warranties', label: 'Warranties & Disclaimers' },
  { id: 'liability', label: 'Limitation of Liability' },
  { id: 'termination', label: 'Termination' },
  { id: 'governing-law', label: 'Governing Law' },
];

export function TermsPage() {
  return (
    <>
      <PageHead
        title="Terms of Service"
        description="NAATS Terms of Service - the contractual terms governing use of our platform and services."
      />
      <div className={styles.inner}>
        <aside className={styles.sidebar}>
          <TableOfContents items={tocItems} />
        </aside>

        <div className={styles.content}>
          <ArticleBody>
            <h1>Terms of Service</h1>
            <p><em>Last updated: January 2026</em></p>

            <h2 id="acceptance">Acceptance of Terms</h2>
            <p>
              By accessing or using the NAATS website, platform, or services (collectively,
              "Services"), you agree to be bound by these Terms of Service ("Terms"). If you
              are accessing the Services on behalf of an organization, you represent that you
              have authority to bind that organization. If you do not agree to these Terms,
              do not use the Services.
            </p>

            <h2 id="services">Use of Services</h2>
            <p>You agree to use our Services only for lawful purposes and in accordance with these Terms. You agree not to:</p>
            <ul>
              <li>Use the Services to violate any applicable law or regulation</li>
              <li>Attempt to gain unauthorized access to any systems or data</li>
              <li>Reverse engineer, decompile, or disassemble any part of the platform</li>
              <li>Use the Services to transmit malicious code or disrupt operations</li>
              <li>Misrepresent your identity or affiliation</li>
            </ul>

            <h2 id="intellectual-property">Intellectual Property</h2>
            <p>
              All content, software, architectures, frameworks, and materials provided through
              NAATS Services are the intellectual property of NAATS or its licensors. Nothing
              in these Terms grants you ownership of any intellectual property rights. You may
              use deliverables created specifically for your engagement as defined in your
              Statement of Work or Master Services Agreement.
            </p>

            <h2 id="confidentiality">Confidentiality</h2>
            <p>
              Each party agrees to maintain the confidentiality of the other party's
              Confidential Information using reasonable care - at least as protective as it
              uses for its own confidential information. Confidential Information excludes
              information that is publicly available, independently developed, or rightfully
              received from third parties without restriction.
            </p>

            <h2 id="warranties">Warranties &amp; Disclaimers</h2>
            <p>
              NAATS provides the website and informational content "as is" without warranties
              of any kind. For professional services engagements, warranties are defined
              specifically in the applicable Master Services Agreement. NAATS makes no
              warranty that the website will be uninterrupted, error-free, or free of viruses.
            </p>

            <h2 id="liability">Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by applicable law, NAATS shall not be liable for
              any indirect, incidental, special, consequential, or punitive damages arising from
              your use of or inability to use the Services. NAATS's total aggregate liability
              for direct damages shall not exceed the amounts paid by you for Services in the
              twelve months preceding the claim.
            </p>

            <h2 id="termination">Termination</h2>
            <p>
              NAATS reserves the right to suspend or terminate access to the Services at any
              time, with or without cause, and with or without notice. Upon termination, your
              right to access the Services immediately ceases. Provisions that by their nature
              should survive termination - including intellectual property, confidentiality,
              and limitation of liability - shall survive.
            </p>

            <h2 id="governing-law">Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with applicable
              law. Any disputes arising from these Terms shall be resolved through binding
              arbitration, except where prohibited by law. You waive any right to a jury trial
              for disputes arising under these Terms.
            </p>
          </ArticleBody>
        </div>
      </div>
    </>
  );
}
